"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var collectionsRef_1 = require("common/db/collectionsRef");
var spin_1 = __importDefault(require("antd/lib/spin"));
var react_i18next_1 = require("react-i18next");
var warehousesList_1 = require("common/global/warehousesList");
var projectsList_1 = require("common/global/projectsList");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var unitsList_1 = require("common/global/unitsList");
var categoriesList_1 = require("common/global/categoriesList");
var exportWarehouseItemsTableToExcel_1 = require("portal/components/Grid/helpers/exportWarehouseItemsTableToExcel");
var button_1 = __importDefault(require("antd/lib/button/button"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var permissiontypes_1 = require("../Users/permissiontypes");
var AddNewMaintenanceItemDialog_1 = __importDefault(require("./AddNewMaintenanceItemDialog"));
var AddRepairedItem_1 = __importDefault(require("./AddRepairedItem"));
function Maintenecance() {
    var _this = this;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)(undefined), modalState = _a[0], setModalState = _a[1];
    var _b = (0, firestore_1.useCollection)(collectionsRef_1.warehouseMaintenanceItemsRef), warehouseMaintenanceItems = _b[0], loadingWarehouseMaintenanceItems = _b[1];
    var warehouseMaintenanceItemsData = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = warehouseMaintenanceItems === null || warehouseMaintenanceItems === void 0 ? void 0 : warehouseMaintenanceItems.docs) === null || _a === void 0 ? void 0 : _a.map(function (item, idx) {
            var data = item.data();
            return __assign(__assign({}, data), { id: item.id, idx: idx + '' });
        });
    }, [warehouseMaintenanceItems]);
    var columnsOfItems = [
        {
            name: 'warehouseId',
            title: t('common.warehouse'),
            getCellValue: function (r) { var _a; return (_a = warehousesList_1.globalWarehousesData[r.warehouseId]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: 'projectId',
            title: t('projects.projectCode'),
            getCellValue: function (r) { var _a; return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.code; },
        },
        {
            name: 'budgetLineId',
            title: t('budget.budgetLine'),
            getCellValue: function (r) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[r.budgetLineId]) === null || _a === void 0 ? void 0 : _a.code; },
        },
        {
            name: 'cachedProductName',
            title: t('products.productName'),
        },
        {
            name: 'cachedProductUnit',
            title: t('common.unit'),
            getCellValue: function (r) { var _a; return (_a = unitsList_1.globalUnitsData[r.cachedProductUnit]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: 'cachedProductDescription',
            title: t('products.description'),
        },
        {
            name: 'cachedProductCategory',
            title: t('common.category'),
            getCellValue: function (r) { var _a; return (_a = categoriesList_1.globalCategoriesData[r.cachedProductCategory]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: 'stockNumber',
            title: t('warehouse.stockNumber'),
        },
        {
            name: 'serialNumbers',
            title: t('warehouse.serialNumbers'),
            getCellValue: function (r) { return r.serialNumber; },
        },
        {
            name: 'assetsNumbers',
            title: t('warehouse.assetsNumbers'),
            getCellValue: function (r) { var _a; return (_a = r.assetsNumbers) === null || _a === void 0 ? void 0 : _a.join(', '); },
        },
        {
            name: 'storageLocation',
            title: t('warehouse.storageLocation'),
        },
        {
            name: 'maintenancePrice',
            title: t('common.maintenancePrice'),
        },
        {
            name: 'status',
            title: t('warehouse.status'),
        },
        {
            name: 'maintenanceNotes',
            title: t('common.maintenanceNotes'),
        },
        {
            name: 'repairNotes',
            title: t('common.repairNotes'),
        },
        {
            name: 'addedToMaintenanceAt',
            title: t('common.addedToMaintenanceAt'),
            getCellValue: function (r) { var _a; return t('common.date', { date: (_a = r.createdAt) === null || _a === void 0 ? void 0 : _a.toDate() }); },
        },
        {
            name: 'repairedAt',
            title: t('common.repairedAt'),
            getCellValue: function (r) { var _a; return t('common.date', { date: (_a = r.repairedAt) === null || _a === void 0 ? void 0 : _a.toDate() }); },
        },
    ];
    if (loadingWarehouseMaintenanceItems) {
        return (0, jsx_runtime_1.jsx)(spin_1.default, {});
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: warehouseMaintenanceItemsData, columns: columnsOfItems, getRowId: function (r) { return r.id; } }, { children: __spreadArray(__spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({}), true), [(0, jsx_runtime_1.jsx)(button_1.default, __assign({ style: { position: 'absolute', right: '225px', marginTop: 16, zIndex: 999 }, onClick: function () { return setModalState('maintenanceItems'); } }, { children: t('common.addMaintenanceItem') })), (0, jsx_runtime_1.jsx)(button_1.default, __assign({ style: { position: 'absolute', right: '408px', marginTop: 16, zIndex: 999 }, onClick: function () { return setModalState('addRepairedItem'); } }, { children: t('common.addRepairedItem') })), (0, permissiontypes_1.permissionTypes)('exportMaintenanceItems') ? ((0, jsx_runtime_1.jsx)(button_1.default, __assign({ style: { position: 'absolute', right: '90px', marginTop: 16, zIndex: 999 }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var fileName, fields, titles;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    fileName = 'Warehouse Items Table';
                                    fields = [
                                        'warehouseId',
                                        'projectId',
                                        'budgetLineId',
                                        'cachedProductName',
                                        'cachedProductDescription',
                                        'cachedProductUnitName',
                                        'cachedProductCategory',
                                        'quantity',
                                        'serialNumbers',
                                        'assetsNumbers',
                                        'stockNumber',
                                        'batchNumber',
                                        'storageLocation',
                                        'expiryDate',
                                    ];
                                    titles = [
                                        'Warehouse',
                                        'Project',
                                        'Budget Line',
                                        'Product Name',
                                        'Product Description',
                                        'Product Unit',
                                        'Product categoty',
                                        'Product Quantity',
                                        'Serial Numbers',
                                        'Assets Numbers',
                                        'Stock Number',
                                        'Batch Number',
                                        'Storage Location',
                                        'Expiry Date',
                                    ];
                                    return [4 /*yield*/, (0, exportWarehouseItemsTableToExcel_1.exportWarehouseItemsTableToExcel)(warehouseMaintenanceItemsData, fields, titles, fileName)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, { children: t('common.exportToExcel') }))) : null, modalState === 'maintenanceItems' ? ((0, jsx_runtime_1.jsx)(AddNewMaintenanceItemDialog_1.default, { modalState: modalState === 'maintenanceItems', setModalState: setModalState })) : null, modalState === 'addRepairedItem' ? ((0, jsx_runtime_1.jsx)(AddRepairedItem_1.default, { modalState: modalState === 'addRepairedItem', setModalState: setModalState })) : null], false) })) }));
}
exports.default = Maintenecance;
